import Vue from 'vue';
import Component from 'vue-class-component';
import { validationMixin } from 'vuelidate';
import { Action, Mutation } from 'vuex-class';
import to from 'await-to-js';
import { AUTH_PENDING } from '@/apps/auth/store/types';


/**
 * Provide base functionality for auth api calls and form validation
 *
 * Data:
 *
 * errors - Stores errors from api.
 * responseData - Stores api response.
 */
@Component({
  name:   'AuthorizationMixin',
  mixins: [
    validationMixin,
  ],
})
export default class AuthorizationMixin extends Vue {
  errors = null;
  responseData = {};

  @Action('') vuexAction;
  @Mutation(AUTH_PENDING) setAuthPending;

  /**
   * Get data to be passed in api call. Should be overwritten.
   */
  getData() {
    throw new Error('Not implemented');
  }

  /**
   * Use vuelidate to check if password field is not none
   * @returns {boolean}
   */
  valid() {
    this.$v.$touch();

    return !this.$v.$error;
  }

  /**
   * Called on form action success.
   * @param data
   */
  handleSuccess(data) {
    this.errors = null;
    this.responseData = data;
  }

  /**
   * Called on form action fail
   * @param errors
   */
  handleErrors(errors) {
    this.errors = errors;
  }

  /* Check if the variable is Object and not null */
  isObject(item) {
    return (typeof item === 'object' && !Array.isArray(item) && item !== null);
  }

  /**
   * Check each property if it's an Object and has $model property
   * and set $model to empty string to clear form fields
   */
  clearFields() {
    Object.values(this.$v).forEach((value) => {
      if (this.isObject(value)) {
        const hasModelProperty = Object.prototype.hasOwnProperty.call(value, '$model');

        if (hasModelProperty) {
          const val = value;

          val.$model = '';
          val.$reset();
        }
      }
    });
  }

  /* Close authorization modal and clear fields */
  close() {
    this.$emit('close');
    this.clearFields();
  }

  /**
   * Handles form submission. Call validation and vuex action.
   * @returns {Promise<void>}
   */
  async formAction() {
    if (!this.valid()) {
      return;
    }

    /**
     * Starts vuex actions and run success and fail callbacks.
     * @returns {Promise<void>}
     */
    const next = async () => {
      this.setAuthPending(true);

      const [ err, data ] = await to(this.vuexAction(this.getData()));

      this.setAuthPending(false);
      if (err) {
        this.handleErrors(err.response.data.detail);
      } else {
        this.handleSuccess(data);
      }

      this.clearFields();
    };

    await next();
  }
}



// WEBPACK FOOTER //
// ./src/apps/auth/mixins/authorization-mixin.js